import { Types } from "../actions/reportActions";
import _ from "lodash";
import { NotificationManager } from "react-notifications";

const defaultState = {
	sidebar: {},
};

const reportReducers = (state = defaultState, action) => {
	switch (action.type) {
		case Types.REPORT_SHOW_PAYPERIOD_MODAL: {
			let newState = _.cloneDeep(state);

			newState.report.payPeriodModalStatus = action.show;

			return newState;
		}
		case Types.REPORT_FILTERS: {
			let newState = _.cloneDeep(state);

			if (!newState.report.filters) {
				newState.report.filters = {};
			}

			newState.report.filters = {
				...newState.report.filters,
				...action.options,
			};

			return newState;
		}
		case Types.REPORT_SAVE_PACKS: {
			let newState = _.cloneDeep(state);

			console.log('newState.advisors.reports.reportPacks',newState.advisors.reports.reportPacks)

			newState.advisors.reports.reportPacks = action.data;

			return newState;
		}
		case Types.REPORT_SAVE_CUSTOM: {
			let newState = _.cloneDeep(state);

			newState.advisors.reports.customReports = action.data;

			return newState;
		}
		case Types.REPORT_SAVE_FAVOURITE: {
			let newState = _.cloneDeep(state);

			newState.company.favouritedReports = action.data;

			return newState;
		}

		default:
			return state;
	}
};

export default reportReducers;
